// X165 (R76 S1, Grant: "a bit of layout shift, especially with the admin breadcrumbs"): the admin trail is page state
// (useState 'adminBreadcrumbs', set by each admin page from its own setup). X56 emptied it in route middleware on every
// path change under /admin, so a page that never set one could not show the previous page's trail. But middleware runs
// BEFORE the new page's async setup resolves while Nuxt keeps the old page on screen, and the bar hid itself when the
// list was empty: on every admin navigation the bar vanished for 20–470 ms, the old page jumped up 49px, then the new
// page landed 49px down again. The rule now: the previous crumbs stay until the new page sets its own; only a page
// that has set none by the time it has finished rendering (Nuxt's page:finish) gets the trail cleared. These three
// steps are pure so the rule is tested; middleware, setAdminBreadcrumbs and the client plugin call them.

/** A navigation that changes the path and touches /admin on either side: the only case the trail is at stake. */
export function isAdminPathChange(to, from) {
  if (!to || to.path === from?.path) return false;
  return to.path.startsWith('/admin') || !!from?.path?.startsWith('/admin');
}

/** Route middleware: the crumbs are kept; the new page now owes its own trail (pending). A query-only change owes nothing. */
export function onPathChange(trail, to, from) {
  if (!isAdminPathChange(to, from)) return trail;
  return {crumbs: trail.crumbs, pending: true};
}

/** setAdminBreadcrumbs: the page has paid: its crumbs show, nothing is owed. */
export function onSet(trail, items) {
  return {crumbs: Array.isArray(items) ? items : [], pending: false};
}

/** page:finish: the new page has rendered; a trail still owed means it set none, so the old one must not linger. */
export function onPageFinish(trail) {
  return trail.pending ? {crumbs: [], pending: false} : trail;
}
